import script from "./PhotosSliderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PhotosSliderModal.vue?vue&type=script&setup=true&lang=js"

import "./PhotosSliderModal.vue?vue&type=style&index=0&id=e8e68d54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8e68d54"]])

export default __exports__